<template>
  <div class="addImages">
    <div class="btns">
      <van-button type="default" size="small" @click="close">取消</van-button>
      <van-button type="info" size="small" @click="submits">确定</van-button>
    </div>
    <div id="materiallists" class="materiallist abcds">
      <van-radio-group v-model="radio">
      <div class="content">
        <div class="photo" :style="{
				height:width + 'px',
				width: width + 'px'
			}">
          <van-uploader :after-read="afterRead"/>
        </div>

          <div class="materia-item" v-for="(item,index) in materialList" :key="index"
               @click="getselevt(index)" :style="{
				height:width + 'px',
				width: width + 'px'
			}">
            <div class="checkbox">
              <van-radio :name="index"></van-radio>
            </div>
            <lazy-component style="width:100%;height: 100%">
              <img :src="upFileUrl + item.screenshotUrl" style="width: 100%;height: 100%;">
            </lazy-component>
          </div>

      </div>
      </van-radio-group>
    </div>
    <div class="groupings">
      <div style="padding: 5px 7px;border: 1px solid #b9b9b9;border-radius: 5px;display: flex;align-items: center;"
           @click="Drawer">
        {{ groupingName }}
        <img src="/static/images/buttom.png" class="arrows">
      </div>
    </div>
    <van-popup
        v-model="show"
        position="left"
        :style="{ height: '100%',width: '50%' }"
    >
      <van-sidebar v-model="activeKey" @change="onChange">
        <van-sidebar-item v-for="(item,index) in tabbar" :title="item.name" :key="index"></van-sidebar-item>
      </van-sidebar>
    </van-popup>
    <van-overlay :show="show1">
      <div style="height: 100%;display: flex;justify-content: center;align-items: center">
        <van-loading size="24px" style="color: #F8F9FD">{{ msg }}...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {Toast} from 'vant'
import qs from 'qs'

export default {
  name: 'addImages',
  data() {
    return {
      width: 0,
      number: 0,
      selectImg: [],
      materia: [],
      show: false,
      tabbar: [],
      groupingName: '',
      activeKey: 0,
      materialList: [],
      allmaterialList: [],
      index: 0,
      isHasMore: true,
      isLoading: false,
      checked: '',
      id: 0,
      show1: true,
      FolderIndex: 0,
      msg: "加载中",
      radio: ""
    }
  },
  mounted() {
    this.width = document.getElementById('materiallists').clientWidth / 4 - 2
    this.getFolder(0)
    const materiallist = document.getElementsByClassName('abcds')[0]
    materiallist.addEventListener('scroll', this.handleScroll)
    this.selectImg = []
  },
  methods: {
    getFolder(index) {
      this.msg = "加载中"
      const p = new Promise((resolve, reject) => {
        this.$ajax.post('/etv/findAllOrOneFolder.json', qs.stringify({
          mtType: 'img',
          type: 'select',
          id: '',
        })).then(res => {
          if (res.data.code === 0) {
            resolve(res.data.data)
          } else {
            reject()
          }
        })
      })
      p.then(res => {
        this.tabbar = res.children

        this.groupingName = this.tabbar[index].name
        this.id = this.tabbar[index].mfId

        this.getmaterial(this.id)
      })
    },
    close() {
      this.$emit('close')
    },
    submits() {
      if (this.selectImg.length === 0) {
        Toast('请选择图片')
        return
      }
      this.$emit('setImages', this.selectImg)
    },
    upImage() {
    },
    Drawer() {
      this.show = true
    },
    onChange(index) {
      this.FolderIndex = index
      this.materialList = []
      this.groupingName = this.tabbar[index].name
      this.getmaterial(this.tabbar[index].mfId)
      this.id = this.tabbar[index].mfId
      this.show = false
      this.show1 = true
    },
    getmaterial(id) {
      this.$ajax.post('/etv/findAllMaterial.json', qs.stringify({
        id,
        type: 'img',
        pageNum: 1,
        pageSize: 99999,
      })).then(res => {
        if (res.data.code === 0) {
          this.allmaterialList = res.data.data.materialList
          this.allmaterialList.map(res => {
            res.checked = false
          })
          this.materialList = this.allmaterialList.slice(this.index, this.index + 28)
          this.$nextTick(() => {
            this.show1 = false
          })
        }
      })
    },
    handleScroll() {
      //滚动条
      const scrollHeight = document.getElementsByClassName('abcds')[0].scrollTop
      let clientHeight = document.getElementsByClassName('content')[0].clientHeight
      let doch = window.screen.height
      //真实高度
      if (clientHeight - doch - scrollHeight < 40) {
        if (this.allmaterialList.slice(this.index * 28, this.index * 28 + 28).length < 28) {
          return
        }
        this.index++
        this.materialList = [...this.materialList, ...this.allmaterialList.slice(this.index * 28, this.index * 28 + 28)]
      }
    },
    getselevt(index) {
      this.radio = index
      this.selectImg = [this.materialList[index]]
    },
    afterRead(file) {

      const imgTypes = ['png', 'jpg', 'jpeg', 'gif']
      if (imgTypes.includes(file.file.name.split('.')[file.file.name.split('.').length - 1].toLowerCase())) {
        this.show1 = true
        this.msg = "上传中"
        const frromData = new FormData()
        frromData.append('files', file.file)
        frromData.append('id', this.id)
        this.$ajax.post(this.upFileUrl + 'etv/insertMaterial.json', frromData, {
          headers: {
            'contentType': 'multipart/form-data',
          },
        }).then(res => {
          if (res.data.code === 0) {
            this.materialList = []
            this.getFolder(this.FolderIndex)
          } else {
            Toast(res.data.msg)
          }
        })
      } else {
        Toast('图片格式错误')
      }
    },
  },
  destroyed() {
    this.materialList = []
  },
}
</script>

<style lang="scss">
@import "../../../public/static/css/app";

.addImages {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 55;
  background: #f1f1f1;

  .btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px;
    border-bottom: 1px solid $uni-border-bottom-color;
  }

  .materiallist {
    width: 100%;
    padding: 2px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 46px;
    bottom: 45px;
    overflow: auto;

    .content {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
    }

    .photo {
      box-sizing: border-box;
      padding: 2px;

      .van-uploader__upload-icon {
        font-size: 48px;
      }

      .van-uploader {
        width: 100%;
        height: 100%;
        border: none;

        .van-uploader__wrapper {
          width: inherit;
          height: inherit;

          .van-uploader__upload {
            width: inherit;
            height: inherit;
            margin: 0 !important;
            border: none;
          }
        }
      }

      .updata-centnt {
        width: 100%;
        height: 100%;
        border-radius: 5px;

        .updata {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          background: #ffffff;

          .updata-img {
            width: 40%;
            height: 40%;
            margin-bottom: 10px;
          }
        }
      }

    }


    .materia-item {
      position: relative;
      padding: 2px;
      box-sizing: border-box;

      .checkbox {
        position: absolute;
        top: 1px;
        left: 2px;
        display: flex;
        justify-content: center;
        align-items: center;

        checkbox {
          width: 25.42px;
          height: 25.42px;
        }
      }

      .image {
        width: 100%;
        height: 100%;
      }
    }
  }

  .groupings {
    display: flex;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    height: 44px;
    align-items: center;
    padding-left: 20px;
    box-sizing: border-box;
    background: #F8F9FD;

    .arrows {
      height: 20px;
      width: 20px;
    }
  }

  .van-sidebar {
    width: 100%;
  }
}


</style>
